var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoutique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.073,
    height: 27.937,
    viewBox: "0 0 26.073 27.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-shop-5352516",
    transform: "translate(-132.33 -46.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_97",
    "data-name": "Trac\\xE9 97",
    d: "M133.876,48.979a9.912,9.912,0,0,0-.626,2.371l-.836,4.178a4.275,4.275,0,1,0,8.446,1.264l.1-.964a4.426,4.426,0,1,0,8.814-.053l.1,1.017a4.275,4.275,0,1,0,8.446-1.264l-.835-4.178a9.921,9.921,0,0,0-.627-2.371,4.192,4.192,0,0,0-2.639-2.164,9.937,9.937,0,0,0-2.447-.149H138.963a9.937,9.937,0,0,0-2.447.149,4.192,4.192,0,0,0-2.639,2.164Z",
    transform: "translate(0 0)",
    fill: "#000a8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_98",
    "data-name": "Trac\\xE9 98",
    d: "M172.319,288.056a6.331,6.331,0,0,0,3.118-.812v1.511c0,5.27,0,7.9-1.637,9.542-1.318,1.318-3.282,1.575-6.747,1.625v-4.879a5.2,5.2,0,0,0-.281-2.446,2.1,2.1,0,0,0-.767-.767,10.782,10.782,0,0,0-4.891,0,2.1,2.1,0,0,0-.767.767,5.2,5.2,0,0,0-.281,2.446v4.879c-3.465-.05-5.43-.307-6.747-1.625-1.637-1.637-1.637-4.272-1.637-9.542v-1.511a6.38,6.38,0,0,0,7.468-.9,6.523,6.523,0,0,0,8.82,0,6.357,6.357,0,0,0,4.35,1.716Z",
    transform: "translate(-18.192 -225.319)",
    fill: "#000a8c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoutique);
export default __webpack_public_path__ + "static/media/boutique.4306616f.svg";
export { ForwardRef as ReactComponent };